import { register } from '@shopify/theme-sections';
import Accordion from '../utilities/accordion';
import '../styles/sections/product-details.scss';

register('product-details', {
    onLoad() {
        const infoContainer = document.getElementsByClassName('product-details__info')[0];
        const tabs = document.querySelectorAll('.product-details__tab');
        tabs.forEach( tab => {
            const dataTab = tab.getAttribute('data-tab');
            const body = tab.querySelector('.product-details__tab-body');
            if (body) {
                const content = body.innerHTML;
                const tabInfo = document.createElement('div');
                tabInfo.className = 'product-details__info-content';
                tabInfo.setAttribute('data-tab',dataTab);
                if (tab.getElementsByClassName('product-details__tab-title--opened').length > 0) {
                    tabInfo.className = 'product-details__info-content product-details__info-content--opened';
                }
                tabInfo.innerHTML = content;
                infoContainer.appendChild(tabInfo);
            }
        });
        const accordion = new Accordion({
            element: '.product-details__accordion',
            titleClass: 'product-details__tab-title',
            onTabOpen: function( element ) {
                const tabIndex = element.parentNode.getAttribute('data-tab');
                const currentTab = infoContainer.querySelector(`.product-details__info-content--opened`);
                if (currentTab) {
                    currentTab.classList.remove('product-details__info-content--opened');
                }
                const tabSelected = infoContainer.querySelector(`[data-tab="${tabIndex}"]`);
                if (tabSelected) {
                    tabSelected.classList.add('product-details__info-content--opened');
                }
            }
        });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
      this.$container.off(this.namespace);
    },
});
